import Button, { ButtonShade } from "components/library/Button";
import Markdown from "markdown-to-jsx";
import Link from "next/link";
import { PostFrontMatter } from "types/PostFrontMatter";
import { Author } from "./Author";
import { BlogTypeAndDate } from "./BlogTypeAndDate";

export const BlogPostPreview = (props: PostFrontMatter) => {
  const { title, date, summary, slug, type, images, authors, thumbnail } =
    props;
  return (
    <article className="relative my-20 rounded-xl bg-white shadow-a md:py-48 md:px-48 lg:px-64">
      <div className="flex flex-col-reverse md:flex-row md:gap-48 lg:gap-64 xl:gap-128">
        <div className="mx-16 my-24 flex flex-col gap-24 md:mx-0 md:my-0 md:w-1/2">
          <div className="mt-8 flex flex-col">
            <BlogTypeAndDate type={type} date={date} />
            <Link key={slug} href={`/blog/${slug}`}>
              <a href={`/blog/${slug}`}>
                <h3 className="mt-8 mb-12 block font-display text-32-40  text-gray-900">
                  {title}
                </h3>
              </a>
            </Link>
            {authors?.map((author) => (
              <Author key={author} author={author} />
            ))}
          </div>
          <p className="text-16-24 text-gray-800">
            <Markdown>{summary}</Markdown>
          </p>
          <div>
            <Button shade={ButtonShade.Blue} href={`/blog/${slug}`}>
              Read more
            </Button>
          </div>
        </div>
        {/* TODO: Image */}
        <img
          alt=""
          className="rounded-ms border border-black/5 object-cover md:w-1/2"
          src={thumbnail || "/assets/documentary/laptop-hands-unsplash.jpg"}
        />
      </div>
    </article>
  );
};
